<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" fullscreen append-to-body
        :close-on-click-modal="false" @closed="handleClosed">
        <div v-loading="loading" class="project-form-dialog-body">
            <el-form ref="form" label-width="120px">
                <!-- 基本信息 -->
                <el-card shadow="never" class="form-card">
                    <div slot="header"><span>基本信息</span></div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="防水项目名称" required>
                                <el-input v-model="formData.name" placeholder="请输入防水项目名称" :disabled="isViewMode" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 服务阶段列表 -->
                <div v-if="!loading" class="stages-container">
                    <div v-for="(stage, stageIndex) in formData.stages" :key="stageIndex" class="stage-card-wrapper">
                        <el-card shadow="never" class="form-card">
                            <div slot="header" class="stage-card-header">
                                <span>服务阶段 {{ stageIndex + 1 }}</span>
                                <el-button v-if="!isViewMode" type="danger" size="mini" plain icon="el-icon-delete"
                                    @click="removeStage(stageIndex)">删除阶段</el-button>
                            </div>

                            <!-- 阶段属性 -->
                            <el-row :gutter="16">
                                <el-col :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="名称" :required="!isViewMode">
                                        <el-input v-model="stage.stageName" placeholder="服务阶段名称" :disabled="isViewMode"
                                            size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="别名">
                                        <el-select v-model="stage.alias" placeholder="请选择别名" :disabled="isViewMode"
                                            size="small" clearable>
                                            <el-option label="基坑" value="基坑" />
                                            <el-option label="回填" value="回填" />
                                            <el-option label="面层" value="面层" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="排序">
                                        <el-input v-model.number="stage.sort" type="number" placeholder="排序"
                                            :disabled="isViewMode" size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="拿货价">
                                        <el-input v-model.number="stage.price" type="number" placeholder="拿货价"
                                            :disabled="isViewMode" size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="阈值">
                                        <el-input v-model.number="stage.threshold" type="number" placeholder="阈值"
                                            :disabled="isViewMode" size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="mode !== 'view'" :xs="12" :sm="6" :md="4" :lg="3">
                                    <el-form-item label="分组">
                                        <el-input v-model.number="stage.costGrouping" type="number" placeholder="分组"
                                            :disabled="isViewMode" size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="8" :lg="4">
                                    <el-form-item label="是否展示">
                                        <el-switch v-model="stage.isShow" active-value="1" inactive-value="2"
                                            active-text="是" inactive-text="否" :disabled="isViewMode" />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- 表单字段配置 -->
                            <div class="fields-section">
                                <div class="fields-header">
                                    <span class="fields-title">表单字段配置</span>
                                    <el-button v-if="!isViewMode" type="primary" size="mini" plain icon="el-icon-plus"
                                        @click="addField(stageIndex)">增加字段</el-button>
                                </div>
                                <el-table :data="stage.formFields" border size="small" style="width: 100%"
                                    :max-height="400" class="fields-table">
                                    <el-table-column type="index" label="序号" width="55" />
                                    <el-table-column label="字段名称" min-width="110">
                                        <template v-slot="scope">
                                            <el-input size="small" v-model="scope.row.fieldName" placeholder="字段名"
                                                :disabled="isViewMode" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="控件类型" width="120">
                                        <template v-slot="scope">
                                            <el-select v-model="scope.row.inputType" placeholder="控件类型" size="small"
                                                :disabled="isViewMode" clearable>
                                                <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                                                    :value="type.id" />
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="数据源" width="120">
                                        <template v-slot="scope">
                                            <el-select v-model="scope.row.dataSource" placeholder="数据源" size="small"
                                                :disabled="isViewMode" clearable>
                                                <el-option v-for="source in dataSources" :key="source.id"
                                                    :label="source.valueName" :value="source.id" />
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="是否展示" width="120" align="center">
                                        <template v-slot="scope">
                                            <el-switch v-model="scope.row.showFlag" active-value="YES"
                                                inactive-value="NO" :disabled="isViewMode" active-text="是"
                                                inactive-text="否" size="small" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="客户端" width="150">
                                        <template v-slot="scope">
                                            <el-select v-model="scope.row.showClient" placeholder="客户端" clearable
                                                multiple size="small" :disabled="isViewMode">
                                                <el-option v-for="client in typeClients" :key="client.value"
                                                    :label="client.label" :value="client.value" />
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="是否为空" width="120" align="center">
                                        <template v-slot="scope">
                                            <el-switch v-model="scope.row.isNull" active-value="YES" inactive-value="NO"
                                                active-text="是" inactive-text="否" :disabled="isViewMode" size="small" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="是否计费" width="120" align="center">
                                        <template v-slot="scope">
                                            <el-switch v-model="scope.row.charging" active-value="YES" active-text="是"
                                                inactive-text="否" inactive-value="NO" :disabled="isViewMode"
                                                size="small" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="计费规则" width="110">
                                        <template v-slot="scope">
                                            <el-input size="small" v-model="scope.row.expression" placeholder="计费规则"
                                                clearable :disabled="isViewMode" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="分享时可见" width="120" align="center">
                                        <template v-slot="scope">
                                            <el-switch v-model="scope.row.shareVisible" active-value="Y"
                                                inactive-value="N" active-text="是" inactive-text="否"
                                                :disabled="isViewMode" size="small" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="客户展示内容" min-width="130">
                                        <template v-slot="scope">
                                            <el-input size="small" v-model="scope.row.shareFieldName"
                                                placeholder="客户展示内容" :disabled="isViewMode" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="排序" width="60">
                                        <template v-slot="scope">
                                            <el-input size="small" v-model="scope.row.sort" :disabled="isViewMode" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="80" align="center" v-if="!isViewMode"
                                        fixed="right">
                                        <template v-slot="scope">
                                            <el-button type="text" size="small"
                                                @click="removeField(stageIndex, scope.$index)" icon="el-icon-delete" />
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                    </div>

                    <!-- 增加阶段按钮 -->
                    <div v-if="!isViewMode" class="add-stage-btn">
                        <el-button type="primary" icon="el-icon-plus" @click="addStage">增加阶段</el-button>
                    </div>
                </div>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">关闭</el-button>
            <el-button v-if="!isViewMode" type="primary" @click="submit" :loading="submitLoading">
                {{ mode === 'add' ? '确认新增' : '确认修改' }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    findWaterProofDynamicId,
    findDataSourceAll,
    findDataSourceFields,
    editWaterProofDynamic,
    addDynamic
} from '@/api/work/waterProof/projectDynamic'

const EMPTY_STAGE = {
    stageName: '',
    alias: '',
    price: '',
    threshold: '',
    sort: '',
    costGrouping: '',
    isShow: '1',
    id: '',
    formFields: []
}

const EMPTY_FIELD = {
    fieldName: '',
    shareFieldName: '',
    inputType: '',
    dataSource: '',
    showClient: [],
    showFlag: 'YES',
    isNull: 'NO',
    charging: 'NO',
    expression: '',
    sort: '',
    shareVisible: 'N'
}

export default {
    name: 'ProjectFormDialog',
    props: {
        visible: { type: Boolean, default: false },
        mode: { type: String, default: 'add' }, // add | edit | view
        projectId: { type: String, default: '' },
        agentId: { type: String, default: '' }
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            submitLoading: false,
            formData: {
                name: '',
                stages: []
            },
            typeClients: [
                { label: '工程师端', value: 'JOINS_ENGINEER' },
                { label: '消费者端', value: 'JOINS_USER' },
                { label: '商户端', value: 'JOINS_MERCHANT' }
            ],
            inputTypes: [],
            dataSources: [],
            additionalFields: {}
        }
    },
    computed: {
        dialogTitle() {
            const map = { add: '新增防水项目', edit: '编辑防水项目', view: '查看防水项目' }
            return map[this.mode] || '防水项目'
        },
        isViewMode() {
            return this.mode === 'view'
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.dialogVisible = val
                if (val) this.open()
            },
            immediate: true
        }
    },
    methods: {
        async open() {
            this.loading = true
            this.submitLoading = false
            this.formData = { name: '', stages: [] }

            try {
                // 并行加载控件类型和数据源
                const [fieldsRes, sourceRes] = await Promise.all([
                    findDataSourceFields(),
                    findDataSourceAll()
                ])
                this.inputTypes = JSON.parse(fieldsRes.data)
                this.dataSources = JSON.parse(sourceRes.data).rows

                if (this.mode === 'add') {
                    this.initEmptyForm()
                } else {
                    await this.loadProjectDetail()
                }
            } catch (e) {
                console.error('初始化加载失败:', e)
                this.$message.error('数据加载失败')
            } finally {
                this.loading = false
            }
        },

        initEmptyForm() {
            this.formData = {
                name: '',
                stages: [{ ...EMPTY_STAGE, formFields: [{ ...EMPTY_FIELD }] }]
            }
            this.additionalFields = {}
        },

        async loadProjectDetail() {
            if (!this.projectId) {
                this.$message.error('缺少项目ID')
                return
            }
            try {
                const res = await findWaterProofDynamicId(this.projectId)
                if (res && (res.code === '200' || res.code === 200)) {
                    const parsedData = JSON.parse(res.data)
                    const data = parsedData.rows && parsedData.rows.length > 0 ? parsedData.rows[0] : parsedData
                    if (!data) {
                        this.$message.error('未找到项目数据')
                        return
                    }
                    this.formData.name = data.name || ''
                    this.additionalFields = { ...data }

                    if (data.list && Array.isArray(data.list)) {
                        this.formData.stages = data.list.map(stage => ({
                            ...stage,
                            stageName: stage.name || '',
                            alias: stage.alias || '',
                            price: stage.price || '',
                            threshold: stage.threshold || '',
                            sort: stage.sort || 0,
                            costGrouping: stage.costGrouping || '',
                            isShow: String(stage.isShow || '1'),
                            id: stage.id || '',
                            formFields: (stage.dynamicFormRequest && stage.dynamicFormRequest.fields
                                ? stage.dynamicFormRequest.fields.map(field => {
                                    const foundType = this.inputTypes.find(t => t.id == field.inputType)
                                    return {
                                        ...field,
                                        id: field.id || '',
                                        fieldName: field.fieldName || '',
                                        shareFieldName: field.shareFieldName || '',
                                        inputType: foundType ? foundType.id : '',
                                        dataSource: field.dataSource || '',
                                        isNull: field.isNull || 'NO',
                                        showFlag: field.showFlag || 'YES',
                                        showClient: field.showClient ? field.showClient.split(',') : [],
                                        charging: field.charging || 'NO',
                                        expression: field.expression || '',
                                        sort: field.sort || 0,
                                        shareVisible: field.shareVisible || 'N'
                                    }
                                })
                                : [])
                        }))
                    } else {
                        this.formData.stages = []
                    }
                } else {
                    this.$message.error(res.message || '获取项目详情失败')
                }
            } catch (e) {
                console.error('获取项目详情失败:', e)
                this.$message.error('获取项目详情失败')
            }
        },

        addStage() {
            this.formData.stages.push({
                ...EMPTY_STAGE,
                formFields: [{ ...EMPTY_FIELD }]
            })
        },

        removeStage(index) {
            this.formData.stages.splice(index, 1)
        },

        addField(stageIndex) {
            this.formData.stages[stageIndex].formFields.push({ ...EMPTY_FIELD })
        },

        removeField(stageIndex, fieldIndex) {
            this.formData.stages[stageIndex].formFields.splice(fieldIndex, 1)
        },

        buildSubmitParams() {
            return {
                ...this.additionalFields,
                id: this.projectId,
                agentId: this.agentId,
                name: this.formData.name,
                type: 'WATERPROOF_PROJECT',
                list: this.formData.stages.map(stage => ({
                    ...stage,
                    name: stage.stageName,
                    alias: stage.alias || '',
                    price: stage.price,
                    threshold: stage.threshold,
                    sort: stage.sort,
                    costGrouping: stage.costGrouping,
                    isShow: stage.isShow,
                    type: 'WATERPROOF_PROJECT',
                    id: stage.id ? stage.id : '',
                    dynamicFormRequest: {
                        ...stage.dynamicFormRequest,
                        fields: stage.formFields.map(field => ({
                            ...field,
                            id: field.id ? field.id : '',
                            fieldName: field.fieldName || '',
                            inputType: field.inputType || '',
                            dataSource: field.dataSource || '',
                            isNull: field.isNull || 'NO',
                            showClient: field.showClient.join(','), // 将数组转换为逗号分隔的字符串
                            charging: field.charging || 'NO',
                            expression: field.expression || '',
                            sort: field.sort || 0,
                            shareVisible: field.shareVisible || 'N',
                            shareFieldName: field.shareFieldName || '',
                            // picUrl: field.picUrl.map(url => (typeof url === 'string' ? url : url.url)).join(','),
                        }))
                    }
                }))
            }
        },

        async submit() {
            if (!this.formData.name) {
                this.$message.warning('请输入防水项目名称')
                return
            }
            this.submitLoading = true
            const params = this.buildSubmitParams()
            try {
                const api = this.mode === 'add' ? addDynamic : editWaterProofDynamic
                const res = await api(params)
                if (res.code === '200') {
                    this.$message.success(this.mode === 'add' ? '新增成功' : '修改成功')
                    this.$emit('submit-success')
                    this.dialogVisible = false
                    this.$emit('update:visible', false)
                    this.$emit('close')
                } else {
                    this.$message.error(res.message || (this.mode === 'add' ? '新增失败' : '修改失败'))
                }
            } catch (e) {
                this.$message.error('请求失败: ' + (e.message || '未知错误'))
            } finally {
                this.submitLoading = false
            }
        },

        handleCancel() {
            this.dialogVisible = false
            this.$emit('update:visible', false)
            this.$emit('close')
        },

        handleClosed() {
            this.$emit('update:visible', false)
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.project-form-dialog-body {
    height: 100%;
    overflow-y: auto;
    padding: 4px 0;
}

.form-card {
    margin-bottom: 16px;

    ::v-deep .el-card__header {
        padding: 10px 16px;
        font-weight: 600;
        background: #fafafa;
        border-bottom: 1px solid #ebeef5;
    }

    ::v-deep .el-card__body {
        padding: 16px;
    }
}

.stage-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.fields-section {
    margin-top: 12px;
    border-top: 1px dashed #e8e8e8;
    padding-top: 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.fields-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.fields-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
}

.fields-table {
    ::v-deep .cell {
        white-space: nowrap;
    }

    ::v-deep .el-switch {
        margin: 0;
    }
}

.add-stage-btn {
    text-align: center;
    margin-top: 16px;
    padding: 16px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        border-color: #409eff;
        background: #ecf5ff;
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
</style>
